import axios from 'axios';
import store from '../store';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  modelosAtividade: [],
  modeloAtividadeChecklists: []
};

const getters = {
  // Modelos Atividade
  modelosAtividade: state => state.modelosAtividade.sort((a,b) => a.Descricao > b.Descricao ? 1 : -1),
  modelosAtividadeAtivo: state => state.modelosAtividade.filter(m => m.Status.startsWith('A')).sort((a,b) => a.Descricao > b.Descricao ? 1 : -1),
  modeloAtividadeChecklists: state => state.modeloAtividadeChecklists,
}

const actions = {
  // Modelos Atividade
  async fetchModelosAtividade({ commit }) {
    try {
      const response = await axios.get(`${baseUrl}/modelosatividades`);
      if (response.data.length) {
        commit('setModelosAtividade', response.data);
      } else {
        commit('setModelosAtividade', []);
      }
    } catch (error) {
      commit('setModelosAtividade', []);
    }
  },
  async fetchModelosAtividadeSql({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/modelosatividades?idLayoutSql=${args.idLayoutSql}`);
      if (response.data.length) {
        commit('setModelosAtividade', response.data);
      } else {
        commit('setModelosAtividade', []);
      }
    } catch (error) {
      commit('setModelosAtividade', []);
    }
  },
  async addModeloAtividade({ commit }, modeloAtividade) {
    const response = await axios.post(`${baseUrl}/modelosatividades`, modeloAtividade);
    modeloAtividade.IdModeloAtividade = response.data.IdModeloAtividade;
    commit('newModeloAtividade', modeloAtividade);
    return response.data.IdModeloAtividade;
  },
  async updateModeloAtividade({ commit }, updModeloAtividade) {
    await axios.put(`${baseUrl}/modelosatividades`, updModeloAtividade);
    commit('updateModeloAtividade', updModeloAtividade);
  },
  async deleteModeloAtividade({ commit }, id) {
    await axios.delete(`${baseUrl}/modelosatividades/${id}`);
    commit('removeModeloAtividade', id);
  },

  // Checklists
  resetaModeloAtividadeChecklists({ commit }) {
    commit('resetaModeloAtividadeChecklists');
  },
  async fetchModeloAtividadeChecklists({ commit }, id) {
    try {
      const response = await axios.get(`${baseUrl}/modelosatividades/${id}/checklists`);
      if (response.data.length) {
        commit('setModeloAtividadeChecklists', response.data);
      } else {
        commit('setModeloAtividadeChecklists', []);  
      }
    } catch (error) {
      commit('setModeloAtividadeChecklists', []);
    }
  },
  async addModeloAtividadeChecklist({ commit }, modeloAtividadeChecklist) {
    const response = await axios.post(`${baseUrl}/modelosatividades/${modeloAtividadeChecklist.IdModeloAtividade}/checklists`, modeloAtividadeChecklist);
    modeloAtividadeChecklist.IdChecklist = response.data.IdChecklist;
    commit('newModeloAtividadeChecklist', modeloAtividadeChecklist);
    return response.data.IdChecklist;
  },
  async updateModeloAtividadeChecklist({ commit }, updModeloAtividadeChecklist) {
    await axios.put(`${baseUrl}/modelosatividades/${updModeloAtividadeChecklist.IdModeloAtividaded}/checklists/${updModeloAtividadeChecklist.IdChecklist}`, updModeloAtividadeChecklist);
    commit('updateModeloAtividadeChecklist', updModeloAtividadeChecklist);
  },
  async deleteModeloAtividadeChecklist({ commit }, checklist) {
    await axios.delete(`${baseUrl}/modelosatividades/${checklist.IdModeloAtividade}/checklists/${checklist.IdChecklist}`);
    commit('removeModeloAtividadeChecklist', checklist.IdChecklist);
  },
}

const mutations = {
  // Modelos Atividade
  setModelosAtividade: (state, modelosAtividade) => state.modelosAtividade = modelosAtividade,
  newModeloAtividade: (state, modeloAtividade) => state.modelosAtividade.push(modeloAtividade),
  removeModeloAtividade: (state, id) => state.modelosAtividade = state.modelosAtividade.filter(modeloAtividade => modeloAtividade.IdModeloAtividade !== id),
  updateModeloAtividade: (state, updModeloAtividade) => {
    const index = state.modelosAtividade.findIndex(modeloAtividade => modeloAtividade.IdModeloAtividade === updModeloAtividade.IdModeloAtividade);
    if (index !== -1) {
      state.modelosAtividade.splice(index, 1, updModeloAtividade);
    }
  },
  // Checklists
  resetaModeloAtividadeChecklists: state => state.modeloAtividadeChecklists = [],
  setModeloAtividadeChecklists: (state, checklists) => state.modeloAtividadeChecklists = checklists,
  newModeloAtividadeChecklist: (state, checklist) => state.modeloAtividadeChecklists.push(checklist),
  removeModeloAtividadeChecklist: (state, id) => state.modeloAtividadeChecklists = state.modeloAtividadeChecklists.filter(checklist => checklist.IdChecklist !== id),
  updateModeloAtividadeChecklist: (state, updModeloAtividadeChecklist) => {
    const index = state.modeloAtividadeChecklists.findIndex(checklist => checklist.IdChecklist === updModeloAtividadeChecklist.IdChecklist);
    if (index !== -1) {
      state.modeloAtividadeChecklists.splice(index, 1, updModeloAtividadeChecklist);
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}